<template>
  <div>
    <v-row justify-sm="end">
      <v-col
        cols="12"
        sm="auto"
        class="text-start"
        style="display: flex; align-items: center"
      >
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("invoice.downloads") }}
        </span>
      </v-col>

      <v-spacer></v-spacer>

      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="search"
          hide-details
          prepend-inner-icon="mdi-magnify"
          color="textLight"
          :placeholder="$t('invoice.search')"
          solo
          flat
          clearable
          :disabled="disabled"
          class="shrink rounded-lg"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "InvoicesTableHeadingAndSearch",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: null,
      previousSearch: null,
      debounceSearch: null,
    };
  },
  watch: {
    search() {
      clearTimeout(this.debounceSearch);

      this.debounceSearch = setTimeout(() => {
        const searchText = this.search?.trim() ?? "";

        if (searchText.length > 3) {
          this.previousSearch = searchText;
          this.$emit("filter", "search", this.previousSearch);
        } else if (searchText.length === 0 && this.previousSearch != null) {
          this.previousSearch = null;
          this.$emit("filter", "search", this.previousSearch);
        }
      }, 500);
    },
  },
};
</script>
